import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import Switch from "react-switch";

import useWindowDimensions from "../../hooks/useWindowDimensions";

import StatusRow from "../StatusRow/StatusRow";
import LoseGame from '../LoseGame/loseGame';

import { MdOutlineRestartAlt } from "react-icons/md";
import Color from "color";
import styles from "../../../games.module.css";

// Update Game component to be more constrained
const Game = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-size: cover;
    background-position: center;
    padding-bottom: 0;
    max-height: calc(100vh - 200px); // Ensure it doesn't exceed viewport height
`;

const ContainerNext = styled.div`
	${props =>
		!props.portrait && `height: ${props.pixelSize * 18 + (18 / 3) * 1}px;`}
	${props => props.portrait && `width: ${props.pixelSize * 10 + (10 / 3) * 1}px;`}
	margin-right: ${props => (props.portrait ? 0 : props.pixelSize / 3)}px;
	margin-bottom: ${props => (props.portrait ? props.pixelSize / 3 : 0)}px;
	display: flex;
	flex-direction: ${props => (props.portrait ? "row" : "column")};
	justify-content: ${props => (props.portrait ? "space-between" : "flex-start")};
	align-items: center;
`;

const Next = styled.div`
	width: ${props => props.pixelSize * 3}px;
	height: ${props => props.pixelSize * 3}px;
	background-color: ${props => (props.theme3d ? "#444" : "black")};
	transition: background-color 0.5;
	border: ${props => props.pixelSize / 10}px solid white;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin-bottom: ${props => (props.portrait ? 0 : props.pixelSize / 3)}px;
	margin-right: ${props => (!props.portrait ? 0 : props.pixelSize / 3)}px;
`;

const StyledStage = styled.div`
	border: ${props => props.pixelSize / 10}px solid white;
	background-color: ${props => (props.theme3d ? "#444" : "black")};
	transition: background-color 0.5s;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	
`;

const Center = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
`;

const Row = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	height: ${props => (props.stage ? props.pixelSize : props.pixelSize / 1.6)}px;
`;

const Pixel = React.memo(styled.div`
	width: ${props => (props.stage ? props.pixelSize : props.pixelSize / 1.6)}px;
	height: ${props => (props.stage ? props.pixelSize : props.pixelSize / 1.6)}px;
	background-color: ${props => (props.fill === 1 ? props.color : "inherited")};
	position: relative;
	z-index: ${props => props.zIndex};

	${props =>
		props.paused &&
		`
		transition: all 1s;
	`};

	${props =>
		props.fill &&
		props.theme3d &&
		`;
		box-shadow: ${props.pixelSize / 4.16}px ${props.pixelSize /
			4.16}px ${props.pixelSize / 5.55}px #222${
			props.topBloco
				? `, 0 ${-props.pixelSize / 4.16}px 0 ${Color(props.color).lighten(0.2)}`
				: ""
		} 
	`};

	${props =>
		!props.theme3d &&
		`
		border-left: 1px solid ${
			props.stage || props.fill || props.hint ? "#222" : "black"
		};
		border-top: 1px solid ${
			props.stage || props.fill || props.hint ? "#222" : "black"
		};	
	`};

	${props =>
		props.hint &&
		`
		border: 1px solid ${Color(props.playerColor).alpha(0.5)};
		background-color: rgba(255,255,255,0.1);
	`};
`);

const ContainerSwitch = styled.div`
	${props =>
		props.portrait &&
		`
		height: 100%;
		width: 100%;
		display: flex;
		align-items: flex-end;
		flex-direction: column;
		justify-content: flex-end;
	`};
`;
/*
const ContainerStatus = styled.div`
	width: ${props => props.pixelSize * 8}px;
	${props =>
		!props.portrait && `height: ${props.pixelSize * 18 + (18 / 3) * 1}px;`}
	${props => props.portrait && `width: ${props.pixelSize * 10 + (10 / 3) * 1}px;`}
	margin-left: ${props => (props.portrait ? 0 : props.pixelSize / 3)}px;
	margin-top: ${props => (props.portrait ? props.pixelSize / 3 : 0)}px;
	display: flex;
	flex-direction: ${props => (props.portrait ? "row" : "column")};
	align-items: center;
	justify-content: ${props => (props.portrait ? "space-between" : "flex-start")};
	font-size: ${props => props.pixelSize}px;
`;
*/

const getRenderizacaoBloco = bloco => {
	let trimRowBloco = [];
	let sumColumn = {};
	bloco.forEach((row, y) => {
		let rowSum = 0;
		row.forEach(pixel => (rowSum = rowSum + pixel));
		if (rowSum > 0) trimRowBloco.push(row);
		row.forEach((pixel, x) => {
			sumColumn[x] = (sumColumn[x] ? sumColumn[x] : 0) + pixel;
		});
	});
	let trimBloco = [];
	trimRowBloco.forEach((row, y) => {
		let newRow = [];
		row.forEach((pixel, x) => {
			if (sumColumn[x] > 0) newRow.push(pixel);
		});
		trimBloco.push(newRow);
	});
	return trimBloco;
};

const Stage = ({ lose, restartClick, map, player, hint, status, paused, ...others }) => {
    const [pixelSize, setPixelSize] = useState(50);
    const [portrait, setPortrait] = useState(false);
    const { width, height } = useWindowDimensions();
    const [theme3d, setTheme3d] = useState(false);
    const [nextRender, setNextRender] = useState();
    const stageRef = useRef(null);

    useEffect(() => {
        setPixelSize(25); // Slightly reduce the initial size to prevent overflow
    }, []);

    useEffect(() => {
        // Calculate available height for the game area with more constraints
        const headerHeight = 180; // Increased to account for padding/margins
        const footerHeight = 20; // Add some bottom margin
        const availableHeight = height - headerHeight - footerHeight;
        
        // Calculate pixel size based on available dimensions with stricter constraints
        let pixelSizeHeight = availableHeight / 23; // Increased divisor to make it smaller
        let pixelSizeWidth = width / 45;  // Increased divisor to make it smaller
        
        if (portrait) {
            pixelSizeHeight = availableHeight / 26;
            pixelSizeWidth = width / 14;
        }
        
        // Use the smaller of the two sizes to ensure full visibility
        const calculatedSize = Math.min(pixelSizeWidth, pixelSizeHeight);
        setPixelSize(Math.max(calculatedSize, 16)); // Reduced minimum size
        
        setPortrait(height > width);
    }, [width, height, portrait]);

    useEffect(() => {
		if (!player.next) return;
		setNextRender(getRenderizacaoBloco(player.next.bloco));
	}, [player.next]);

	useEffect(() => {
		if (!lose) {
			stageRef.current.focus();
		}
	}, [lose]);

	useEffect(() => {
		stageRef.current.focus();
	}, [theme3d]);

	const exitGame = () => {
		window.location.href = "/games";
	  };

    return (
        <div className="h-screen bg-[var(--background-color)] flex flex-col overflow-hidden">
            {/* Title at the Top with reduced margins */}
            <div className="max-w-7xl mx-auto w-full px-4 pt-2 pb-1">
                <h1 className="font-['Jersey_25',sans-serif] text-2xl md:text-3xl font-bold text-center mb-2 text-yellow-500 bg-gradient-to-r from-[var(--primary-color)] via-[var(--interactive-color)] to-[var(--accent-color)] text-transparent bg-clip-text transform transition-all">
                    Tetris
                </h1>

                <div className="bg-[var(--surface-color)] rounded-xl shadow-lg overflow-hidden border border-[var(--border-color)] mb-2">
                    {/* Status Rows at the Top - Reduced padding */}
                    {status && (
                        <div className="bg-[var(--primary-color)] py-1 px-3">
                            <div className="flex items-center">
                                <div className="text-white text-base w-full flex justify-between items-center p-1">
                                    {/* Further reduced padding and text sizes */}
                                    <div className="flex items-center gap-3">
                                        <h1 className="text-lg font-bold text-[var(--text-color)]">
                                            <StatusRow
                                                title="Score: "
                                                value={status.score}
                                            />
                                        </h1>
                                        <h1 className="text-lg font-bold text-[var(--text-color)]">
                                            <StatusRow title="Lives: " value={status.lives} isLives={true} />
                                        </h1>
                                    </div>

                                    <div className="flex items-center gap-2">
                                        <button
                                            className="group relative inline-flex items-center px-3 py-1 bg-[var(--interactive-color)] text-white rounded-lg text-sm font-bold transform transition-all duration-300 hover:bg-opacity-90 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[var(--interactive-color)] focus:ring-offset-2 focus:ring-offset-[var(--background-color)]"
                                            onClick={restartClick}
                                        >
                                            <MdOutlineRestartAlt className="mr-1 text-sm" />
                                            Restart
                                        </button>

                                        <button
                                            className="group relative inline-flex items-center px-3 py-1 bg-[var(--error-color)] text-white rounded-lg text-sm font-bold transform transition-all duration-300 hover:bg-opacity-90 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-[var(--error-color)] focus:ring-offset-2 focus:ring-offset-[var(--background-color)]"
                                            onClick={exitGame}
                                        >
                                            Exit
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Game Area - Make it flex-grow to fill available space with no padding */}
            <div className="flex-grow flex items-center justify-center">
                <Game portrait={portrait}>
                    {nextRender && (
						<ContainerNext portrait={portrait} pixelSize={pixelSize}>
							<Next portrait={portrait} theme3d={theme3d} pixelSize={pixelSize}>
								{nextRender.map((row, y) => (
									<Row pixelSize={pixelSize} key={`row-${y}`}>
										{row.map((pixel, x) => {
											let topBloco = pixel && (!nextRender[y - 1] || !nextRender[y - 1][x]);
											return (
												<Pixel
													paused={paused}
													theme3d={theme3d}
													topBloco={topBloco}
													zIndex={y}
													pixelSize={pixelSize}
													key={`pixel-${x}`}
													fill={pixel}
													color={player.next.color}
												/>
											);
										})}
									</Row>
								))}
							</Next>
							<ContainerSwitch portrait={portrait}>
								<Switch
									width={pixelSize * 2}
									height={pixelSize / 1.2}
									onChange={setTheme3d}
									checked={theme3d}
									offColor="#000"
									onColor="#444"
									uncheckedIcon={
										<Center>
											<Pixel
												theme3d={false}
												pixelSize={pixelSize / 3}
												stage="true"
												fill={1}
												color={"#e54b4b"}
											/>
										</Center>
									}
									checkedIcon={
										<Center>
											<Pixel
												theme3d="true"
												pixelSize={pixelSize / 3}
												stage="true"
												fill={1}
												color={"#e54b4b"}
												topBloco="true"
											/>
										</Center>
									}
								/>
							</ContainerSwitch>
						</ContainerNext>
					)}
					{map && (
						<StyledStage ref={stageRef} {...others} theme3d={theme3d} pixelSize={pixelSize}>
							{map.map((row, y) => (
								<Row stage="true" pixelSize={pixelSize} key={`row-${y}`}>
									{row.map((pixel, x) => {
										let playerFill =
											player.bloco.bloco[y - player.pos[0]] &&
											player.bloco.bloco[y - player.pos[0]][x - player.pos[1]];
										let playerHint =
											hint.bloco.bloco[y - hint.pos[0]] &&
											hint.bloco.bloco[y - hint.pos[0]][x - hint.pos[1]];
										let topBloco =
											(playerFill || pixel.fill) &&
											(!player.bloco.bloco[y - player.pos[0] - 1] ||
												!player.bloco.bloco[y - player.pos[0] - 1][x - player.pos[1]]) &&
											(!map[y - 1] || !map[y - 1][x].fill);
										let zIndex = !playerFill && !pixel.fill && playerHint ? 99 : y;
										return (
											<Pixel
												paused={paused}
												theme3d={theme3d}
												hint={!pixel.fill && !playerFill && playerHint}
												pixelSize={pixelSize}
												stage="true"
												key={`pixel-${x}`}
												fill={pixel.fill || playerFill}
												color={playerFill ? player.bloco.color : pixel.color}
												playerColor={player.bloco.color}
												topBloco={topBloco}
												zIndex={zIndex}
											></Pixel>
										);
									})}
								</Row>
							))}
						</StyledStage>
					)}
                </Game>
                {lose && 
					<LoseGame portrait={portrait} restartClick={restartClick} status={status} pixelSize={pixelSize} theme3d={theme3d}>
					</LoseGame>}
            </div>
        </div>
    );
};

export default Stage;